<div class="text-center">
  <mat-progress-bar mode="determinate" [value]="employee() | employeeProfile" />
  <mat-hint>{{ employee() | employeeProfile }}%</mat-hint>
</div>
